import React from 'react';
import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import { useAppTheme } from './theme';
import { SnackbarProvider } from 'notistack';
import useRouterProvider from './routes';
import CssBaseline from '@mui/material/CssBaseline';
import Notifications from './containers/Notifications';
import { RouterProvider } from 'react-router-dom';

function App() {
  const theme = useAppTheme();
  const router = useRouterProvider();

  return (
    <ThemeProvider theme={theme}>
    <CssBaseline />
    <SnackbarProvider maxSnack={3}>
      <Notifications />
      <RouterProvider router={router} />
    </SnackbarProvider>
  </ThemeProvider>
  );
}

export default App;
